export enum ItemType {
  Image = 0,
  Gif = 1,
  Video = 2
}
